import { encode } from "html-entities";
import urlRegex from "url-regex";

import { emojis } from "../constants";
import { validators } from "./validator";

export function convertMessage(text: string): string {
	let replacedText = text;
	emojis.forEach((emoji) => {
		replacedText = replacedText.replace(new RegExp(emoji.pattern), () => {
			return emoji.value;
		});
	});
	replacedText = encode(replacedText);
	emojis.forEach((emoji) => {
		replacedText = replacedText.replaceAll(encode(emoji.value), () => {
			return emoji.value;
		});
	});
	replacedText = replacedText.replace(urlRegex({ strict: false }), (url) => {
		if (new RegExp(validators.emailInString).test(url)) {
			return `<a href="mailto:${url}">${url}</a>`;
		}
		let href = url;
		if (!url.match(/^https?:\/\//)) {
			href = `http://${url}`;
		}

		return `<a href="${href}">${url}</a>`;
	});
	replacedText = replacedText.replace(new RegExp(validators.bold), (bold) => {
		return `<b>${bold.slice(1, -1)}</b>`;
	});
	replacedText = replacedText.replace(
		new RegExp(validators.italic),
		(italic) => {
			return `<i>${italic.slice(1, -1)}</i>`;
		},
	);
	replacedText = replacedText.replace(
		new RegExp(validators.lineThrough),
		(lineThrough) => {
			return `<s>${lineThrough.slice(1, -1)}</s>`;
		},
	);

	return replacedText;
}
